import * as React from "react";
import { Path, Rect } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const SMSColoured = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.455 3C3.547 3 2 4.513 2 6.378v7.794c0 1.866 1.547 3.379 3.455 3.379h.542c.652 0 1.179.532 1.172 1.184a1.172 1.172 0 0 0 1.838.977l2.434-1.682c.451-.312.987-.48 1.536-.48h4.569c1.907 0 3.454-1.512 3.454-3.378V6.378C21 4.513 19.453 3 17.546 3H5.455Z"
        fill="#067AD8"
      />
      <Rect
        x={5.402}
        y={7}
        width={5.719}
        height={1.629}
        rx={0.815}
        fill="#fff"
      />
      <Path
        d="M5.402 11.073c0-.45.365-.815.815-.815h9.808a.815.815 0 1 1 0 1.63H6.217a.815.815 0 0 1-.815-.815Z"
        fill="#fff"
      />
    </Icon>
  );
};

export default SMSColoured;
